import { ListingCardMarkerOverlay } from './ListingCardMarkerOverlay';

export class ListingEstimatorCardMarkerOverlay extends ListingCardMarkerOverlay {}
